import React, { useState } from 'react';
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogTrigger,
} from "../../components/ui/alert-dialog";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";

import Close from '../../assets/kinologyIcons/svg/close.svg';
import { panelCreatedProps } from './Dashboard';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { FiltroTypes } from './Funcs';
import { AppActions } from '../../store/ducks/app';
import { TypesErrorRequest } from '../../utils/types';

interface PanelProps {
	openPanel: boolean;
	close:()=> void;
	newPanel: (panel:panelCreatedProps)=> void
};

interface panelsSaved {

	FILTRO_DASH_ATUALIZADO: string;
	FILTRO_DASH_CRIADO: string;
	FILTRO_DASH_NOME: string;
	FILTRO_DASH_VALORES:FiltroTypes;
	ID_FILTRO: string;
}

const CreatePanel: React.FC<PanelProps> = ({
	newPanel,
	close,
	openPanel,
})=> {
	const dispatch = useDispatch();
	
	const panelsSaved: Array<panelsSaved>  = useSelector(
		(state: any) => state.dashboard.data_panels_saved
	);
	const [panelName, setPanelName] = useState('');
		
	const handleNewDash = ()=> {

		const findPanelCreated = panelsSaved.find((panel)=> panel.FILTRO_DASH_NOME == panelName )
		if(findPanelCreated){
			dispatch(AppActions.set_toast_visible({
				status_toast: true,
				type_toast: TypesErrorRequest.FAIL,
				message_toast: 'Já existe um painel com este nome',
			}))
		}else {
			newPanel({
				txDataHora: moment(new Date()).format("YYYY-MM-DD HH:mm:ss").toString(),
				FILTRO_DASH_NOME: panelName,
				filtro: {
					ano: [],
					mes: [],
					protocolo: [],
					exercicio: [],
					cargo: [],
					sexo: [],
					condicionamento: [],
					etiqueta: [],
					avaliador: [],
					articulacao: [],
					data: [],
					entrance_door_data: [],
					gerencias: [],
					alteracoes: []
				},
				visualizacao: [],
			}), 
			close(),
			setPanelName('')
		}

	};

	return (
		<AlertDialog 
			open={openPanel} 
			onOpenChange={()=>close()}
		>
			<AlertDialogContent
				className={`w-6/12 bg-[#F1F2F3] flex flex-col items-center justify-center p-10 rounded-xl`}
			>
				<AlertDialogTrigger className={`absolute right-5 top-5`} onClick={()=>	setPanelName('')}>
					<img src={Close} alt="" className={`w-4 h-4 cursor-pointer`} />
				</AlertDialogTrigger>
				<AlertDialogDescription className={`text-center  text-[#000E4B] font-bold text-xl font-[Noto Sans]`}
				>
					Criar Painel
				</AlertDialogDescription>
				<AlertDialogDescription className={`text-center mt-5 text-[#000E4B] font-semibold text-xs font-[Noto Sans] self-start`}
				>
					Nome do novo painel
				</AlertDialogDescription>
				<Input
					type="text"
					value={panelName}
					onChange={(e) => setPanelName(e.target.value)}
					placeholder="Digite aqui"
					className={`bg-white text-[#3D4259] text-xl font-[Noto Sans] font-normal focus-visible:ring-0`}
				/>
				<AlertDialogDescription className={`text-right mb-4  text-[#797D8D] font-normal text-xs font-[Noto Sans] self-end`}
				>
					20 caracteres
				</AlertDialogDescription>
				<Button
					onClick={() =>{handleNewDash()}}
					className={`
						w-full p-4 items-center bg-[#000E4B] text-[#FAFAFA] font-semibold font-[Kanit-Regular]
						${panelName.length == 0 && `pointer-events-none  bg-[#AEA9B4]` }
					`}
				>
					Salvar
				</Button>
			</AlertDialogContent>
		</AlertDialog>
	);
};
export default CreatePanel;